import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const desktopQuery = '(min-width: 980px)';

function onMediaChange(media: MediaQueryList, listener: () => void) {
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', listener);
  } else {
    (media as { addListener(listener: () => void): void }).addListener(listener);
  }
}

function initVideoReviews(element: HTMLElement) {
  const root = element.closest<HTMLElement>('.pdr-video-reviews__carousel');
  const media = window.matchMedia(desktopQuery);
  let swiper: Swiper | null = null;

  const init = () => {
    root?.classList.add('is-reinitializing');
    swiper?.destroy(true, true);
    root?.classList.toggle('is-desktop', media.matches);

    swiper = new Swiper(element, {
      modules: media.matches ? [Navigation] : [],
      direction: 'horizontal',
      slidesPerView: media.matches ? 2 : 1,
      spaceBetween: 20,
      speed: 350,
      breakpoints: media.matches
        ? {
            1200: {
              spaceBetween: 40,
            },
          }
        : undefined,
      navigation: media.matches
        ? {
            nextEl:
              root?.querySelector<HTMLElement>('.pdr-video-reviews__button--next') ?? undefined,
            prevEl:
              root?.querySelector<HTMLElement>('.pdr-video-reviews__button--prev') ?? undefined,
          }
        : undefined,
    });

    window.requestAnimationFrame(() => {
      root?.classList.remove('is-reinitializing');
    });
  };

  init();

  onMediaChange(media, init);
}

function initWrittenReviews(element: HTMLElement) {
  const root = element.closest<HTMLElement>('.pdr-written-reviews__carousel');
  const media = window.matchMedia(desktopQuery);
  let swiper: Swiper | null = null;

  const init = () => {
    swiper?.destroy(true, true);

    swiper = new Swiper(element, {
      modules: media.matches ? [Navigation] : [Pagination],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 350,
      pagination: !media.matches
        ? {
            el: root?.querySelector<HTMLElement>('.pdr-written-reviews__pagination') ?? undefined,
            clickable: true,
          }
        : undefined,
      navigation: media.matches
        ? {
            nextEl:
              root?.querySelector<HTMLElement>('.pdr-written-reviews__button--next') ?? undefined,
            prevEl:
              root?.querySelector<HTMLElement>('.pdr-written-reviews__button--prev') ?? undefined,
          }
        : undefined,
    });
  };

  init();

  onMediaChange(media, init);
}

export function reviews() {
  document.querySelectorAll<HTMLElement>('.js-pdr-video-reviews').forEach(initVideoReviews);
  document.querySelectorAll<HTMLElement>('.js-pdr-written-reviews').forEach(initWrittenReviews);
}
